import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-442fd325"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card d-inline-block text-start" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Profile")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "text-secondary" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "text-secondary" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangePassword = _resolveComponent("ChangePassword")!
  const _component_Center = _resolveComponent("Center")!

  return (_openBlock(), _createBlock(_component_Center, { class: "h-100" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.fullname), 1),
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.email), 1),
          _hoisted_5,
          (_ctx.changingPassword)
            ? (_openBlock(), _createBlock(_component_ChangePassword, {
                key: 0,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changingPassword = false))
              }))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changingPassword = true))
              }, "Change Password"))
        ])
      ])
    ]),
    _: 1
  }))
}